export const contactPoland = {
  name: "ANIXE Polska Sp. z o.o.",
  streetAndNumber: "Grabiszyńska 251a",
  postcodeAndCity: "53-234 Wrocław",
  country: "Poland",
  phoneSales: "tel: +48 71 364 79 50",
  phoneSupport: "tel: +48 71 364 79 48",
  fax: "fax: +48 71 363 21 02",
};
